import styled from 'styled-components'
import theme from '../../Layout/theme'

export const TitleWrapper = styled.div`
  padding: 10px;
  @media (max-width: 575.98px) {
    padding: 10px 0;
    text-align: center;
  }
`

export const Title = styled.h1`
  color: ${theme.colors.primary};
  font-family: ${theme.fonts.PlayfairDisplay};
  font-size: 32px;
  font-weight: bold;
  letter-spacing: -0.3px;
  line-height: 40px;
  margin: 0;
  @media screen and (max-width: 1024px) {
  font-size: 24px;
  }
  @media screen and (max-width: 768px) {
  font-size: 28px;
  }
`

export const SubTitle = styled.h2`
  color: ${theme.colors.gold};
  font-family: ${theme.fonts.PlayfairDisplay};
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.3px;
  line-height: 28px;
  margin-bottom: 0px;
  @media screen and (max-width: 1024px) {
  font-size: 18px;
  }
  @media screen and (max-width: 768px) {
  font-size: 21px;
  }
`
